import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { FileService } from '../../../onboarding/services/file.service';
import { saveAs as importedSaveAs } from "file-saver";
import { FileNamePipe } from '../../../onboarding/pipes/file-name.pipe';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-documents-page',
  templateUrl: './documents-page.component.html',
  styleUrls: ['./documents-page.component.scss']
})
export class DocumentsPageComponent implements OnInit {
  sub: any;
  orgId: number;
  files: any;
  businessConsentFormUrl = environment.businessConsentFormUrl;
  remittanceVerificationUrl = environment.remittanceVerificationUrl;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private FileService: FileService,
    private FileNamePipe: FileNamePipe,
    private titleService: Title
  ) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
      this.FileService.getFiles(this.orgId)
        .subscribe(files => {
          this.files = JSON.parse(files.document || '{}');
        }, err => {
          console.log(err)
          if (err.status == 401) {
            localStorage.clear();
            this.router.navigate(['/']);
          }
        })
    });

    this.titleService.setTitle('Documents');
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  downloadFile(type: string, path: string) {
    this.FileService.downloadFile(this.orgId, type)
      .subscribe(blob => {
        let fileName = path;
        importedSaveAs(new Blob([blob]), fileName);
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/components/documents-page/documents-page.component.ts